// GA4 measurement ID — not a secret, it's already public in every gtag network request.
export const GA_MEASUREMENT_ID = 'G-S71KT9XVZY';
